import { Button, Form } from 'antd';
import { FC } from 'react';

type SubmitButtonProps = {
	text: string;
	loading?: boolean;
	disabled?: boolean;
	className?: string;
	classNameWrapper?: string;
	onClick?: () => void;
	htmlType?: 'submit' | 'button';
};

export const SubmitButton: FC<SubmitButtonProps> = ({
	text,
	loading,
	disabled,
	className,
	htmlType = 'submit',
	classNameWrapper,
	onClick,
}) => {
	return (
		<Form.Item className={classNameWrapper}>
			<Button
				className={className}
				type="primary"
				block
				size="large"
				htmlType={htmlType}
				loading={loading}
				disabled={disabled}
				onClick={onClick}
			>
				{text}
			</Button>
		</Form.Item>
	);
};
